import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicModifDateOver = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Vos inscriptions', link: '/topics/inscription/modification'},
    { label: topic.title, link: topic.link},
  ];

  // <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Si vous devez effectuer un changement de dernière minute après la date limite de modification, plusieurs solutions s'offrent à vous.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Le plus simple est de contacter directement l'organisateur pour lui exposer votre problème et demander un changement d'informations. 
              </p>
              <p className="help-text">
                Lui seul pourra prendre une décision et vous orienter au mieux.
                Pour en savoir plus sur<a target='_blank' className="link" href='/topics/inscription/34'>comment le contacter</a>.
              </p>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part">{topic.subtitles[1]}</p>
              <p className="help-text">
                Vous pouvez également nous<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>écrire</a>directement. 
                Nous transmettrons votre demande à l'organisateur et vous tiendrons informé dans les plus brefs délais.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicModifDateOver